import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import HeaderLinks from 'components/Header/HeaderLinks.jsx';

// backgroundImage for Sidebar
import image from 'assets/img/full-screen-image-3.jpg';
// logo for sidebar
// import logo from "logo.svg";
import logo from 'assets/img/aaa-lc-logowhite.png';

import dashboardRoutes from 'routes/dashboard.jsx';
import dashboardAdminRoutes from 'routes/dashboardAdmin.jsx';
import dashboardMatrizRoutes from 'routes/dashboardMatriz.jsx';
import dashboardSupportRoutes from 'routes/dashboardSupport.jsx';

import auth from '../../libCustom/auth';

const bgImage = { backgroundImage: 'url(' + image + ')' };

var ps;

const styles = {
  userSection: {
    backgroundColor: 'rgba(51, 65, 85, 0.5)',
    padding: '16px',
    borderBottom: '1px solid #475569',
  },
  userName: {
    fontWeight: '600',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'white',
  },
  userEmail: {
    fontSize: '12px',
    color: '#cbd5e1',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: '2px',
  },
  franchiseBadge: {
    marginTop: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'rgba(245, 158, 11, 0.2)',
    border: '1px solid rgba(245, 158, 11, 0.3)',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    borderRadius: '9999px',
  },
  franchiseDot: {
    width: '6px',
    height: '6px',
    backgroundColor: '#fbbf24',
    borderRadius: '50%',
  },
  franchiseText: {
    fontSize: '12px',
    color: '#fde68a',
    fontWeight: '500',
  },
  roleBadge: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    gap: '6px',
    marginTop: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    borderRadius: '9999px',
    fontSize: '10px',
    fontWeight: '600',
    backgroundColor: 'rgba(16, 185, 129, 0.15)',
    border: '1px solid rgba(16, 185, 129, 0.35)',
  },
  rolDot: {
    width: '6px',
    height: '6px',
    backgroundColor: '#10b981',
    borderRadius: '50%',
  },
  roleBadgeAdmin: {
    fontSize: '10px',
    color: '#6ee7b7',
    fontWeight: '500',
  },

  roleBadgeMatriz: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    gap: '6px',
    marginTop: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    borderRadius: '9999px',
    fontSize: '10px',
    fontWeight: '600',
    backgroundColor: 'rgba(59, 130, 246, 0.15)', // azul suave
    border: '1px solid rgba(59, 130, 246, 0.35)',
  },
  roleTextMatriz: {
    fontSize: '10px',
    color: '#7dd3fc',
    fontWeight: '500',
  },
  rolDotMatriz: {
    width: '6px',
    height: '6px',
    backgroundColor: '#2563a8',
    borderRadius: '50%',
  },

  roleBadgeSupport: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    gap: '6px',
    marginTop: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    borderRadius: '9999px',
    fontSize: '10px',
    fontWeight: '600',
    backgroundColor: 'rgba(126, 34, 206, 0.15)', // morado suave
    border: '1px solid rgba(126, 34, 206, 0.35)',
  },
  rolDotSupport: {
    width: '6px',
    height: '6px',
    backgroundColor: '#7e22ce',
    borderRadius: '50%',
  },
  roleTextSupport: {
    fontSize: '10px',
    color: '#d8b4fe',
    fontWeight: '500',
  },

  roleBadgeSales: {
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    gap: '6px',
    marginTop: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '2px',
    paddingBottom: '2px',
    borderRadius: '9999px',
    fontSize: '10px',
    fontWeight: '600',
    backgroundColor: 'rgba(157, 23, 77, 0.15)', // rosa oscuro suave
    border: '1px solid rgba(157, 23, 77, 0.35)',
  },
  rolDotSales: {
    width: '6px',
    height: '6px',
    backgroundColor: '#9d174d',
    borderRadius: '50%',
  },
  roleTextSales: {
    fontSize: '10px',
    color: '#f9a8d4',
    fontWeight: '500',
  },
  rolesContainer: {
    display: 'flex',
    flexWrap: 'wrap', // por si no caben, bajan en otra línea
    gap: '6px', // espacio entre badges
  },
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute('/components') !== '' ? true : false,
      openForms: this.activeRoute('/forms') !== '' ? true : false,
      openTables: this.activeRoute('/tables') !== '' ? true : false,
      openMaps: this.activeRoute('/maps') !== '' ? true : false,
      openPages: this.activeRoute('/pages') !== '' ? true : false,
      isWindows: navigator.platform.indexOf('Win') > -1 ? true : false,
      width: window.innerWidth,
      route: [],
    };
  }

  componentWillMount() {
    let currentRoute = [];

    if (auth.can('support')) {
      currentRoute = dashboardSupportRoutes;
    } else if (auth.can('matriz')) {
      currentRoute = dashboardMatrizRoutes;
    } else if (auth.can('admin')) {
      currentRoute = dashboardAdminRoutes;
    } else {
      currentRoute = dashboardRoutes;
    }

    this.setState({
      route: currentRoute,
    });
  }

  getRenderUser() {
    const user = auth.getCurrentUser();

    const nameUser = `${user.firstName} ${user.lastName}`;
    const emailUser = user.email;
    const franchiseUser = user.franchise.name;

    const ROLE_CONFIG = {
      admin: {
        badgeStyle: 'roleBadge',
        rolDotStyle: 'rolDot',
        textStyle: 'roleBadgeAdmin',
      },
      adminHotel: {
        badgeStyle: 'roleBadge',
        rolDotStyle: 'rolDot',
        textStyle: 'roleBadgeAdmin',
      },
      matriz: {
        badgeStyle: 'roleBadgeMatriz',
        rolDotStyle: 'rolDotMatriz',
        textStyle: 'roleTextMatriz',
      },
      support: {
        badgeStyle: 'roleBadgeSupport',
        rolDotStyle: 'rolDotSupport',
        textStyle: 'roleTextSupport',
      },
      sales: {
        badgeStyle: 'roleBadgeSales',
        rolDotStyle: 'rolDotSales',
        textStyle: 'roleTextSales',
      },
      gestorCaidas: {
        badgeStyle: 'roleBadgeSupport',
        rolDotStyle: 'rolDotSupport',
        textStyle: 'roleTextSupport',
      },
    };

    const nameRol = {
      admin: 'Administrador',
      matriz: 'Matriz',
      support: 'Soporte',
      sales: 'Ventas',
      adminHotel: 'Administrador de Hotel',
      fallManager: 'Gestor de Caídas',
    };

    const rolUser = user.roles
      .filter((rol) => ROLE_CONFIG[rol])
      .map((rol) => ({ rol: nameRol[rol], ...ROLE_CONFIG[rol] }));

    return (
      <div style={styles.userSection}>
        {/* <div>
          <h3 style={styles.userName}>{nameUser}</h3>
        </div> */}
        <div>
          <h3 style={styles.userName}>{franchiseUser}</h3>
        </div>
        <div>
          <p style={styles.userEmail}>{nameUser}</p>
        </div>
        <div>
          <p style={styles.userEmail}>{emailUser}</p>
        </div>

        {/*<div style={styles.franchiseBadge}>
          <div style={styles.franchiseDot}></div>
          <span style={styles.franchiseText}>{franchiseUser}</span>
        </div>*/}

        <div style={styles.rolesContainer}>
          {rolUser.map((rol, index) => (
            <div key={index} style={styles[rol.badgeStyle]}>
              <div style={styles[rol.rolDotStyle]}></div>
              <div style={styles[rol.textStyle]}>{rol.rol}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  }
  // if the windows width changes CSS has to make some changes
  // this functions tell react what width is the window
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    // add event listener for windows resize
    window.addEventListener('resize', this.updateDimensions.bind(this));
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.refs.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentDidUpdate() {
    if (navigator.platform.indexOf('Win') > -1) {
      setTimeout(() => {
        ps.update();
      }, 350);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
    }
  }
  render() {
    return (
      <div className="sidebar" data-color="black" data-image={image}>
        <div className="sidebar-background" style={bgImage} />
        <div className="logo">
          <a href="/#/admin/dashboard" className="simple-text logo-normal">
            <div className="logo-img">
              <img
                src={logo}
                alt="react-logo"
                style={{ width: '50%', marginLeft: 10 }}
              />
            </div>
          </a>
        </div>
        <div className="sidebar-wrapper" ref="sidebarWrapper">
          {this.getRenderUser()}
          <ul className="nav">
            {/* If we are on responsive, we want both links from navbar and sidebar
               to appear in sidebar, so we render here HeaderLinks */}
            {this.state.width <= 992 ? <HeaderLinks /> : null}
            {/*
               here we render the links in the sidebar
               if the link is simple, we make a simple link, if not,
               we have to create a collapsible group,
               with the speciffic parent button and with it's children which are the links
               */}
            {this.state.route.map((prop, key) => {
              var st = {};
              st[prop['state']] = !this.state[prop.state];
              if (prop.invisible) return null;
              if (prop.collapse) {
                return (
                  <li className={this.activeRoute(prop.path)} key={key}>
                    <a
                      onClick={() => {
                        this.setState(st);
                      }}
                    >
                      <i className={prop.icon} />
                      <p>
                        {prop.name}
                        <b
                          className={
                            this.state[prop.state]
                              ? 'caret rotate-180'
                              : 'caret'
                          }
                        />
                      </p>
                    </a>
                    <Collapse in={this.state[prop.state]}>
                      <ul className="nav">
                        {prop.views.map((prop, key) => {
                          if (prop.invisible) return null;
                          return (
                            <li
                              className={this.activeRoute(prop.path)}
                              key={key}
                            >
                              <NavLink
                                to={prop.path}
                                className="nav-link"
                                activeClassName="active"
                              >
                                <span className="sidebar-mini">
                                  {prop.mini}
                                </span>
                                <span className="sidebar-normal">
                                  {prop.name}
                                </span>
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    </Collapse>
                  </li>
                );
              } else {
                if (prop.redirect) {
                  return null;
                } else {
                  return (
                    <li className={this.activeRoute(prop.path)} key={key}>
                      <NavLink
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                      >
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </NavLink>
                    </li>
                  );
                }
              }
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx